<div class="st-add-publication-channel-label">{{ languageSettings.PSTWebNPCHLabel }}</div>
<mat-divider class="st-add-publication-channel-divider" />
<form
    [formGroup]="publicationChannelGroup"
    (ngSubmit)="addChannel()">
    <div class="st-add-publication-channel-container">
        <mat-form-field subscriptSizing="dynamic">
            <mat-label>{{ languageSettings.PSTWebNameLabel }}</mat-label>
            <input
                matInput
                formControlName="channelName"
                [placeholder]="languageSettings.PSTWebNameLabel" />
        </mat-form-field>
        @if (inputData.externalActionsList?.length) {
            <mat-form-field>
                <mat-label>{{ languageSettings.PSTWebWorkFlowLabel }}</mat-label>
                <mat-select
                    formControlName="channelAction"
                    [placeholder]="languageSettings.PSTWebWorkFlowLabel">
                    @for (item of inputData.externalActionsList; track item) {
                        <mat-option [value]="item.id">
                            {{ item.id }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
        @if (inputData.typePropertyList?.length) {
            <mat-form-field>
                <mat-label>{{ languageSettings.PSTWebPlanningViewType }}</mat-label>
                <mat-select
                    formControlName="channelType"
                    [placeholder]="languageSettings.PSTWebPlanningViewType">
                    @for (option of inputData.typePropertyList; track option) {
                        <mat-option [value]="option.id">
                            {{ option.title }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
        @if (inputData.schedulePropertyList?.length) {
            <mat-form-field>
                <mat-label>{{ languageSettings.PSTWebScheduleLabel }}</mat-label>
                <mat-select
                    formControlName="channelSchedule"
                    [placeholder]="languageSettings.PSTWebScheduleLabel">
                    @for (option of inputData.schedulePropertyList; track option) {
                        <mat-option [value]="option.id">
                            {{ option.title }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
        <mat-form-field subscriptSizing="dynamic">
            <mat-label>{{ languageSettings.PSTWebSectionsLabel }}</mat-label>
            <input
                matInput
                formControlName="channelSections"
                [placeholder]="languageSettings.PSTWebSectionsLabel" />
        </mat-form-field>
        @if (inputData.channelRevisionsList?.length) {
            <mat-form-field>
                <mat-label>{{ languageSettings.PSTWebRevisionsLabel }}</mat-label>
                <mat-select
                    formControlName="channelRevisions"
                    [placeholder]="languageSettings.PSTWebRevisionsLabel">
                    @for (option of inputData.channelRevisionsList; track option) {
                        <mat-option [value]="option.id">
                            {{ option.title }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
        <mat-form-field subscriptSizing="dynamic">
            <mat-label>{{ languageSettings.PSTWebPublicationChannelEditionNames }}</mat-label>
            <input
                matInput
                formControlName="channelEditionNames"
                [placeholder]="languageSettings.PSTWebPublicationChannelEditionNames" />
        </mat-form-field>
    </div>
    <mat-divider class="st-add-publication-channel-divider" />
    <mat-button-toggle-group class="st-add-publication-channel-button-group">
        <button
            mat-button
            class="st-add-publication-channel-button-cancel"
            (click)="cancelNew()">
            {{ languageSettings.PSTWebCancelButtonLabel }}
        </button>
        <button
            mat-button
            type="submit"
            class="st-add-publication-channel-button-confirm"
            [disabled]="loading">
            @if (!loading) {
                {{ languageSettings.PSTWebConfirmButtonLabel }}
            } @else {
                <st-loader
                    class="st-add-publication-channel-button-confirm--spinner"
                    [diameter]="30"
                    [strokeWidth]="5" />
            }
        </button>
    </mat-button-toggle-group>
</form>
